import {CommonDetailViewModel} from './common-detail-view.model';
import { CustomerOrganizationName} from '../customer-organization-name.model';

export class OrganizationDetailViewModel extends CommonDetailViewModel {

    public nameDetail: CustomerOrganizationName;
    public dbas: CustomerOrganizationName[];
    public isACP: boolean;
    public level: number;

    constructor() {
        super();

        this.nameDetail = new CustomerOrganizationName();
        this.dbas = new Array();
    }
}
